import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const userMetadataService = {
  getAllUserMetadata,
  getUserMetadata,
  approveUserMetadata,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = {
    page: filter?.pageNumber,
    size: filter?.pageSize,
  }
  filter?.searchArray?.forEach((word, idx) => {
    if (word !== null && word !== '') params[`search_words[${idx}]`] = word
  })
  if (filter?.dateFrom) params.date_from = filter.dateFrom
  if (filter?.dateTo) params.date_to = filter.dateTo
  return params
}

export async function getAllUserMetadata(filter) {
  return apiHelper(API_URL).get('/user-metadatas', { params: buildParams(filter) })
}

export async function getUserMetadata(uuid) {
  return apiHelper(API_URL).get(`/user-metadatas/${uuid}`)
}

export async function approveUserMetadata(uuid) {
  return apiHelper(API_URL).patch(`/user-metadatas/${uuid}/approve`)
}
